export const en = {
    'clear-all-areas': 'Clear all areas',
    'clear-area': 'Clear area',
    'draw-area': 'Draw area',
    'show-selected': 'Show selections'
};
